import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=63db3901&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"
import style0 from "./Accordion.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Accordion.vue?vue&type=style&index=1&id=63db3901&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63db3901",
  null
  
)

export default component.exports